import React, { useEffect, useState } from "react";
import BreadCrumbBanner from "../component/BreadCrumbBanner";
import aboutAPI from "../api/aboutApi";

const Branches = () => {
  const [branches, setBranches] = useState([]);

  useEffect(() => {
    fetchBranches();
  }, []);

  const fetchBranches = async () => {
    const res = await aboutAPI.branches();
    if (res.code === 200) {
      const result = res.data;
      setBranches(result);
    }
  };

  return (
    <>
      <BreadCrumbBanner
        title="Branches"
        backgroundImage={`${process.env.PUBLIC_URL}/assets/img/about-top2.webp`}
      />

      {/* Branches section */}
      <section className="branch-showcase-section">
        <div className="container">
          {branches &&
            branches.length > 0 &&
            branches.map((item, index) => (
              <div
                key={item.id}
                className={`row align-items-center g-md-5 g-3 branch-row ${index % 2 !== 0 ? "flex-lg-row-reverse" : ""}`}
              >
                {/* Image */}
                <div className="col-lg-6">
                  <div className="branch-showcase-img">
                    <img src={item?.image} alt={item.address1} loading="lazy" />
                  </div>
                </div>

                {/* Content */}
                <div className="col-lg-6">
                  <div className="branch-showcase-content">
                    <span className="mrv-subtitle">{item.type}</span>
                    <h2 className="mrv-title m-0">{item.address1}</h2>
                    <p className="branch-address">{item.address2}</p>
                    <p
                      className="branch-desc"
                      dangerouslySetInnerHTML={{ __html: item.description }}
                    />
                    {item.location && (
                      <a
                        href={item.location}
                        target="_blank"
                        rel="noreferrer"
                        className="branch-map-btn"
                      >
                        View on Map <i className="bi bi-arrow-right" />
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
        </div>
      </section>
    </>
  );
};

export default Branches;
